import { render, staticRenderFns } from "./Panel.vue?vue&type=template&id=026fc563"
import script from "./Panel.vue?vue&type=script&lang=js"
export * from "./Panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('026fc563')) {
      api.createRecord('026fc563', component.options)
    } else {
      api.reload('026fc563', component.options)
    }
    module.hot.accept("./Panel.vue?vue&type=template&id=026fc563", function () {
      api.rerender('026fc563', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic/Panel.vue"
export default component.exports